import React from 'react';
import { cn } from '@/lib/utils';

const InfoCard = ({ label, subtext }) => {
  return (
    <div className="max-w-[150px] rounded-xl bg-gray-100 py-4 px-3 shadow-md">
      <p
        className={cn(
          'mb-2 text-center font-manrope text-[14.2px] font-extrabold capitalize leading-[14.2px] tracking-normal text-[#009378]',
          'md:text-[22.61px] md:leading-[22.61px]',
        )}
      >
        {label}
      </p>
      <p
        className={cn(
          'text-center font-manrope text-[11.04px] font-extrabold capitalize leading-[14.2px] tracking-normal text-black',
          'md:text-[14px] md:leading-[22.61px]',
        )}
      >
        {subtext}
      </p>
    </div>
  );
};

export default InfoCard;
